module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"pt-BR":{"person-not-found":"Pessoa não encontrada","info-do-not-belong-to-me":"Pessoa adicionada via convite","info-is-being-processed":"A imagem está sendo processada...","info-no-face":"Nenhum rosto foi encontrado na imagem.","is-me":"Esta pessoa sou eu","is-dependent":"Esta pessoa é meu dependente","title":"Editar"}}')
  delete Component.options._Ctor
}
